import { PageShell } from '../components/PageShell';

/**
 * ClientesBranded — cópia NATIVA do app legado de Clientes (gestaoclientes),
 * idêntica em estrutura/controles/JS/backend, com APENAS o branding re-skinado
 * para a identidade clara/azul da agenda (override de variáveis de tema em
 * public/gestaoclientes-mmc/index.html). Embutida sob o PageShell numa nova aba.
 *
 * A aba original "👥 Clientes" (gestaoclientes, tema escuro) permanece intacta.
 */
export function ClientesBranded() {
  return (
    <PageShell
      titulo={<h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100">Clientes (converter para react JS)</h1>}
      className="flex flex-col h-screen overflow-hidden"
      semMain
    >
      <div className="flex-1 w-full relative">
        <iframe
          src="/gestaoclientes-mmc/index.html"
          className="w-full h-full border-none bg-transparent"
          allowTransparency={true}
          title="Gestão de Clientes (novo visual)"
        />
      </div>
    </PageShell>
  );
}
